import { render, staticRenderFns } from "./budget@.vue?vue&type=template&id=55ce7b5a&"
import script from "./budget@.vue?vue&type=script&lang=ts&"
export * from "./budget@.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports